import { CartToQuoteRequest } from './../../../../common/models/apttus/request-response/cart-to-quote-request';

export interface CessazioniBBRes {
    oobRequest: CartToQuoteRequest;
    outcomePrevalenceDesc: string;
    outcomePrevalence: OutcomePrevalence;
}

export enum OutcomePrevalence {
    OkPrevalenza = 'OK Prevalenza',
    OkCondizinato = 'OK Condizionato',
    Ok = 'OK'
}
